import { useAuth0 } from '@auth0/auth0-react';
import useGetAccessToken from 'components/Dashboard/apiCalls/useGetAccessToken';
import { netApiClient } from 'api/apiClient';

const useApiRequest = () => {
  const { isAuthenticated } = useAuth0();
  const { getAccessToken } = useGetAccessToken();

  const request = async ({
    method,
    pathname,
    data,
    signal,
    authenticated = true,
    client = netApiClient,
    notShowErrorMessage,
    errorMessage,
    headers: callerHeaders,
    ...axiosOptions
  }) => {
    const token = authenticated && isAuthenticated ? await getAccessToken() : null;
    try {
      return await client.request({
        method,
        url: pathname,
        data,
        signal,
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...callerHeaders,
        },
        notShowErrorMessage,
        errorMessage,
        ...axiosOptions,
      });
    } catch (error) {
      if (error.name === 'CanceledError') {
        console.error(error?.config?.signal?.reason);
      }
      throw error;
    }
  };

  return { request };
};

export default useApiRequest;
